(function () {
    var cookie_settings = ';path=/;max-age=' + 3600 * 24 * 365;
    $.get('/cookies/bar', function (response) {
        $('body').append(response);
        $('body').addClass('body--cookie-bar');
        if (window.afterCookieBarAdd) {
            window.afterCookieBarAdd.call($('#cookie-bar'));
        }
    });

    $(document).on('click', '#cookie-accept', function (e) {
        e.preventDefault();
        document.cookie = 'icc_accept=1' + cookie_settings;
        document.cookie =
            'icc_prefs=' +
            encodeURIComponent(
                'performance=1&functionality=1&analytics=1&advertising=1'
            ) +
            cookie_settings;
        var cookieBar = $('#cookie-bar');
        cookieBar.remove();
        $('body').removeClass('body--cookie-bar');
        if (window.afterCookieBarRemove) {
            window.afterCookieBarRemove.call(cookieBar);
        }
    });
})();
